import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(({ palette, spacing }) => ({
  content: {
    padding: `${spacing(36, 20, 16, 20)} !important`,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(24),
  },
  subtitle: {
    fontSize: spacing(16),
  },
  required: {
    color: palette.error.main,
    marginLeft: spacing(4),
    marginRight: spacing(4),
    fontSize: spacing(14),
  },
  emphasis: {
    fontWeight: 600,
  },
  text: {
    fontSize: spacing(14),
  },
}))
